var _excluded = ["checked", "defaultChecked", "children", "style", "onChange", "indeterminate", "className", "disabled", "size"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { cx } from '@emotion/css';
import { GroupContext } from "./Group";
import { styleCheckbox, prefix, prefixCompName } from "./index.style";
import useThemeProps from "../../hooks/useThemeProps";

var InternalCheckbox = function InternalCheckbox(_ref, ref) {
  var _cx;

  var checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      children = _ref.children,
      style = _ref.style,
      onChange = _ref.onChange,
      indeterminate = _ref.indeterminate,
      className = _ref.className,
      disabled = _ref.disabled,
      size = _ref.size,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var checkboxGroup = React.useContext(GroupContext);
  var c = useThemeProps();

  var _React$useState = React.useState(Boolean(checked) || Boolean(defaultChecked)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentChecked = _React$useState2[0],
      setCurrentChecked = _React$useState2[1];

  var prevValue = React.useRef(restProps.value);

  var checkboxProps = _objectSpread({}, restProps);

  var mergedDisabled = (checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.disabled) || disabled;

  var onChangeHandler = function onChangeHandler(e) {
    var _checkboxGroup$toggle;

    if (mergedDisabled) {
      e.stopPropagation();
      return;
    }

    var targetChecked = e.target.checked;
    onChange === null || onChange === void 0 ? void 0 : onChange(targetChecked, e);

    if (checked === undefined) {
      setCurrentChecked(targetChecked);
    }

    checkboxGroup === null || checkboxGroup === void 0 ? void 0 : (_checkboxGroup$toggle = checkboxGroup.toggleOption) === null || _checkboxGroup$toggle === void 0 ? void 0 : _checkboxGroup$toggle.call(checkboxGroup, {
      label: children,
      value: restProps.value
    });
  };

  if (checkboxGroup) {
    checkboxProps.name = checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.name;
  }

  var checkedIcon = React.useCallback(function (fill) {
    return /*#__PURE__*/React.createElement("svg", {
      width: "1em",
      height: "1em",
      viewBox: "0 0 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.53447 6.4699C3.2417 6.17688 2.76683 6.17667 2.47381 6.46944C2.18079 6.76221 2.18058 7.23708 2.47335 7.5301L5.47075 10.5301C5.76367 10.8233 6.23885 10.8233 6.53181 10.5302L11.5287 5.53016C11.8215 5.23718 11.8213 4.7623 11.5283 4.4695C11.2354 4.1767 10.7605 4.17685 10.4677 4.46984L6.00137 8.93894L3.53447 6.4699Z",
      fill: c[fill]
    }));
  }, [c]);
  var stopPropagation = React.useCallback(function (e) {
    return e.stopPropagation();
  }, []);
  React.useEffect(function () {
    var _checkboxGroup$regist;

    checkboxGroup === null || checkboxGroup === void 0 ? void 0 : (_checkboxGroup$regist = checkboxGroup.registerValue) === null || _checkboxGroup$regist === void 0 ? void 0 : _checkboxGroup$regist.call(checkboxGroup, restProps.value); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(function () {
    if (restProps.value !== prevValue.current) {
      var _checkboxGroup$cancel, _checkboxGroup$regist2;

      checkboxGroup === null || checkboxGroup === void 0 ? void 0 : (_checkboxGroup$cancel = checkboxGroup.cancelValue) === null || _checkboxGroup$cancel === void 0 ? void 0 : _checkboxGroup$cancel.call(checkboxGroup, prevValue.current);
      checkboxGroup === null || checkboxGroup === void 0 ? void 0 : (_checkboxGroup$regist2 = checkboxGroup.registerValue) === null || _checkboxGroup$regist2 === void 0 ? void 0 : _checkboxGroup$regist2.call(checkboxGroup, restProps.value);
      prevValue.current = restProps.value;
    }

    return function () {
      return checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(restProps.value);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [restProps.value]);
  React.useEffect(function () {
    if (checked !== undefined) {
      setCurrentChecked(Boolean(checked));
    } // Group children & no checked


    if (checkboxGroup !== null && checkboxGroup !== void 0 && checkboxGroup.value) {
      setCurrentChecked(checkboxGroup.value.indexOf(restProps.value) !== -1);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [checked, checkboxGroup]);
  return /*#__PURE__*/React.createElement("label", {
    style: style,
    className: cx(styleCheckbox(c), prefix('wrapper')(), (_cx = {}, _defineProperty(_cx, prefix('wrapper-disabled')(), mergedDisabled), _defineProperty(_cx, prefix('wrapper-checked')(), currentChecked && !indeterminate), _defineProperty(_cx, prefix('wrapper-small')(), size === 'small'), _cx), className)
  }, /*#__PURE__*/React.createElement("span", {
    className: cx(prefixCompName(), _defineProperty({}, prefix('checked')(), currentChecked && !indeterminate))
  }, /*#__PURE__*/React.createElement("input", _extends({}, checkboxProps, {
    ref: ref,
    onChange: onChangeHandler,
    disabled: mergedDisabled,
    checked: currentChecked,
    className: prefix('input')(),
    type: "checkbox"
  })), /*#__PURE__*/React.createElement("span", {
    className: cx(prefix('inner')(), _defineProperty({}, prefix('inner-indeterminate')(), indeterminate)),
    onTransitionEnd: stopPropagation
  }, currentChecked && !indeterminate && checkedIcon(mergedDisabled ? 'fourth' : 'background'))), children !== undefined && /*#__PURE__*/React.createElement("span", null, children));
};

var Checkbox = /*#__PURE__*/React.forwardRef(InternalCheckbox);
Checkbox.displayName = 'Checkbox';
Checkbox.defaultProps = {
  disabled: false,
  indeterminate: false,
  defaultChecked: false,
  size: 'large'
};
export default /*#__PURE__*/React.memo(Checkbox);